"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAdapter = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
class DefaultAdapter {
    constructor(oracleId, url) {
        this.oracleId = oracleId;
        this.url = url;
    }
    getOracleId() {
        return this.oracleId;
    }
    async fetchOffchainData(_client, _oracleContract, oracleQuery) {
        return this.fetch(oracleQuery);
    }
    async fetch(data) {
        const response = await (0, node_fetch_1.default)(this.url, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: data,
        });
        if (response.status !== 200) {
            throw new Error(`error fetching data (${response.status}): ${await response.text()}`);
        }
        return (await response.text());
    }
}
exports.DefaultAdapter = DefaultAdapter;
//# sourceMappingURL=default.js.map